// extracted by mini-css-extract-plugin
export default {"chip":"StatusChip_chip__r8112","small":"StatusChip_small__-JP0l","medium":"StatusChip_medium__ifClM","soft":"StatusChip_soft__7k9gN","icon":"StatusChip_icon__O5WZA"};